import axios from 'axios';

export default {
    drivers: function(url, query, updateTime, updateHandler) {
        return createLoader(process.env.VUE_APP_SERVER + url, query, updateTime, function(items) {
            this.items = items;

            updateHandler(this.items);
        });
    },
    orderPings: function(url, updateTime, updateHandler) {
        return createLoader(url, {}, updateTime, function(items) {
            updateHandler(items.filter((it) => it.status == 'searching'));
        });
    }
};

function createLoader(url, query, updateTime, dataHandler) {
    const loader = {
        items: [],
        interval: null,
        updatedAfter: null,

        worker: function() {
            if (self.lastUpdatedAt) {
                Object.assign(query, {
                    updatedAfter: this.lastUpdatedAt
                });
            }

            axios.get(url, { params: query }).then(res => {
                if (!res || !res.data) {
                    return;
                }

                const items = res.data;
                if (items.length > 0) {
                    this.lastUpdatedAt = items.max('updatedAt').updatedAt;
                }

                dataHandler.call(this, items);
            });
        },

        cancel: function() {
            if (this.interval) {
                clearInterval(this.interval);
                this.interval = null;
            }
        }
    };

    const worker = loader.worker.bind(loader);
    loader.interval = setInterval(worker, updateTime);
    worker();

    return loader;
}
